/* DEM PADEL Quiz logic */
(function(){
  const root=document.querySelector('[data-quiz]');
  if(!root||!window.QUIZ_PRODUCTS)return;
  const PRODUCTS=window.QUIZ_PRODUCTS;
  /* Mapping 2026 -> 2025 équivalent (raquette présentée dans "Tu pourrais aussi aimer") */
  const EQUIV_2025={aire:'armonia',agua:'sombra',fuego:'prestige'};
  /* Scoring sur les 3 raquettes 2026 uniquement — priorisées comme nouvelle collection */
  const SCORES={
    niveau:{debutant:{aire:4,agua:1},progresse:{aire:2,agua:3,fuego:1},confirme:{agua:2,fuego:3},competiteur:{fuego:4}},
    style:{defensif:{aire:2,agua:3},polyvalent:{agua:3,fuego:2},agressif:{fuego:3}},
    priorite:{controle:{aire:3,agua:3},polyvalence:{agua:2,fuego:3},puissance:{fuego:4}},
    bras:{sensible:{aire:3,agua:2},ok:{fuego:1,agua:1}},
    frequence:{rare:{aire:2},regulier:{agua:2,fuego:1},intensif:{fuego:3,agua:1}}
  };
  const REASONS={
    aire:["Toucher soft et très tolérante — parfaite pour progresser sans douleur","Équilibre moyen-bas pour une maniabilité optimale","La nouvelle référence pour débuter ou jouer en douceur"],
    agua:["Combo unique contrôle + puissance — ultra polyvalente","Mousse Multilayer Hybrid pour une sortie de balle maîtrisée","S'adapte à tous les profils de joueurs et tous les styles"],
    fuego:["Puissance et précision : explosivité à chaque frappe","Mousse EVA 30 et surface Carbon 3K rugueuse pour un toucher net","La nouvelle référence des joueurs intermédiaires à avancés"],
    armonia:["Manuelle facile — parfait pour progresser sans douleur","Forme tolérante, idéale pour les bras sensibles","Meilleur rapport plaisir/contrôle pour démarrer"],
    sombra:["Contrôle bluffant avec une vraie tenue dans le temps","Maniable et précise — tu places exactement où tu veux","L'équilibre parfait entre puissance et précision"],
    tormenta:["Puissance brute pour finir tes points au filet","Carbone 12K rigide — chaque frappe est explosive","Construite pour résister à un jeu intense et exigeant"],
    prestige:["Top de gamme : puissance sans sacrifier la précision","Polyvalence absolue, performante dans tous les contextes","Choisie par les compétiteurs exigeants"]
  };
  const state={step:'intro',answers:{},history:[]};
  const $=(s,c)=>(c||root).querySelector(s);
  const $$=(s,c)=>[...(c||root).querySelectorAll(s)];
  const fmtEUR=(cents)=>new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(cents/100);

  function go(step){
    $$('[data-step]').forEach(el=>{el.hidden=el.dataset.step!==step});
    state.step=step;
    updateProgress();
    if(window.innerWidth<900)window.scrollTo({top:root.offsetTop-20,behavior:'smooth'});
  }
  function updateProgress(){
    const prog=$('[data-progress]');if(!prog)return;
    const idx=['q1','q2','q3','q4','q5'].indexOf(state.step);
    if(idx>=0){
      prog.hidden=false;
      const pct=((idx+1)/5)*100;
      const fill=$('[data-progress-fill]');if(fill)fill.style.width=pct+'%';
      const curr=$('[data-q-current]');if(curr)curr.textContent=idx+1;
    }else{prog.hidden=true}
  }
  function next(){
    const map={intro:'q1',q1:'q2',q2:'q3',q3:'q4',q4:'q5',q5:'email',email:'result'};
    return map[state.step]||'result';
  }
  function compute(){
    const scores={aire:0,agua:0,fuego:0};
    Object.entries(state.answers).forEach(([q,a])=>{
      const m=(SCORES[q]||{})[a]||{};
      Object.entries(m).forEach(([p,pts])=>{if(scores[p]!==undefined)scores[p]+=pts});
    });
    return Object.entries(scores).sort((a,b)=>b[1]-a[1]).map(e=>e[0]);
  }
  function showResult(){
    const ranked=compute();const main=ranked[0]||'agua';const p=PRODUCTS[main];if(!p)return;
    $('[data-result-name]').textContent=p.name;
    $('[data-result-img]').src=p.image;
    $('[data-result-img]').alt=p.name;
    $('[data-result-tagline]').textContent=p.tagline;
    $('[data-result-price-current]').textContent=p.price;
    const payEl=$('[data-result-pay]');
    if(payEl&&p.priceRaw){const per=Math.round(p.priceRaw/3);payEl.textContent=fmtEUR(per)}
    $('[data-result-link]').href=p.url;
    const reasons=$('[data-result-reasons]');if(reasons)reasons.innerHTML=(REASONS[main]||[]).map(r=>'<li>'+r+'</li>').join('');
    const atc=$('[data-result-atc]');
    atc.onclick=function(){
      if(p.variantId&&window.demAdd){window.demAdd(p.variantId,1)}
      else{window.location.href=p.url}
    };
    const alts=$('[data-result-alts]');
    if(alts){
      /* Affiche l'équivalent 2025 de la raquette recommandée */
      const equivKey=EQUIV_2025[main];
      const a=equivKey?PRODUCTS[equivKey]:null;
      if(a){
        alts.innerHTML='<a class="quiz__alt" href="'+a.url+'"><img src="'+a.image+'" alt="'+a.name+'"><div><strong>'+a.name+'</strong><span>'+a.price+'</span></div></a>';
      }else{
        alts.innerHTML='';
      }
    }
    go('result');
  }

  $('[data-quiz-start]').addEventListener('click',()=>{state.history=['intro'];go('q1')});
  $$('[data-step^="q"] [data-answer]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const panel=btn.closest('[data-step]');
      const q=panel.dataset.question;
      state.answers[q]=btn.dataset.answer;
      $$('.quiz__option',panel).forEach(o=>o.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      state.history.push(state.step);
      setTimeout(()=>{go(next())},220);
    });
  });
  const backBtn=$('[data-quiz-back]');
  if(backBtn)backBtn.addEventListener('click',()=>{if(state.history.length){const p=state.history.pop();go(p)}});
  const skip=$('[data-quiz-skip]');
  if(skip)skip.addEventListener('click',e=>{e.preventDefault();showResult()});
  const form=$('[data-email-form]');
  if(form)form.addEventListener('submit',e=>{
    e.preventDefault();
    const fd=new FormData(form);
    fd.set('contact[note]','Quiz reco: '+JSON.stringify(state.answers));
    fetch('/contact#newsletter',{method:'POST',body:fd}).catch(()=>{}).finally(showResult);
  });
  const restart=$('[data-quiz-restart]');
  if(restart)restart.addEventListener('click',()=>{
    state.answers={};state.history=[];
    $$('.quiz__option').forEach(o=>o.classList.remove('is-selected'));
    go('intro');
  });
})();
